import { useState } from 'react';

import '../graph.scss';
import { CustomAlert, CustomButton } from '../../../shared/uiComponents';
import { useSelector } from '../../../redux/store';
import { ViewAnnotationRow } from './ViewAnnotationRow';

type AnnotationType = 'target' | 'behavior';

interface ViewAnnotationProperties {
	id: string;
	name: string;
	type: AnnotationType;
}

const ViewAnnotation = ({ id, type }: ViewAnnotationProperties) => {
	const [viewAnnotations, setViewAnnotations] = useState<boolean>(false);
	const annotationsList = useSelector((state) =>
		type === 'target' ? state.graphAnnotation.targetAnnotations : state.graphAnnotation.behaviorAnnotations,
	);

	return (
		<>
			<CustomButton title="View Annotations" onClick={() => setViewAnnotations(true)} />
			<CustomAlert
				title="View Annotations"
				onClose={() => setViewAnnotations(false)}
				open={viewAnnotations}
				Content={() => (
					<>
						<div className="graphAnnotationsViewContainer">
							{annotationsList?.map((item) => (
								<ViewAnnotationRow item={item} type={type} key={item.id} clientId={id} />
							))}
						</div>
						<div className="graphAnnotationsContainer">
							<CustomButton title="Close" buttonType="secondaryGray" onClick={() => setViewAnnotations(false)} />
						</div>
					</>
				)}
			/>
		</>
	);
};

export default ViewAnnotation;
